(() => {
  'use strict';

  const roots = document.querySelectorAll(
    '[data-f2w-fighter-directory]'
  );

  if (!roots.length) return;

  roots.forEach((root) => {
    const grid = root.querySelector(
      '[data-f2w-fighter-results]'
    );

    const cards = Array.from(
      root.querySelectorAll('[data-f2w-fighter-card]')
    );

    const countrySelect = root.querySelector(
      '[data-f2w-filter-country]'
    );

    const sportSelect = root.querySelector(
      '[data-f2w-filter-sport]'
    );

    const roleSelect = root.querySelector(
      '[data-f2w-filter-role]'
    );

    const resetButton = root.querySelector(
      '[data-f2w-filter-reset]'
    );

    const countElement = root.querySelector(
      '[data-f2w-results-count]'
    );

    const emptyElement = root.querySelector(
      '[data-f2w-fighter-empty]'
    );

    const paginationElement = root.querySelector(
      '[data-f2w-fighter-pagination]'
    );

    const labels = {
      results: root.dataset.labelResults || ''
    };

    const perPage = parseInt(
      root.dataset.perPage,
      10
    ) || 48;

    let currentPage = 1;

    const normalize = (value) => {
      return String(value || '')
        .toLocaleLowerCase('nl-NL')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    };

    const splitLabels = (value) => {
      return String(value || '')
        .split('|')
        .map((item) => item.trim())
        .filter(Boolean);
    };

    const uniqueSorted = (values) => {
      const labelsByKey = new Map();

      values
        .map((value) => String(value || '').trim())
        .filter(Boolean)
        .forEach((value) => {
          const key = normalize(value);

          if (!labelsByKey.has(key)) {
            labelsByKey.set(key, value);
          }
        });

      return [...labelsByKey.values()]
        .sort((a, b) => a.localeCompare(b, 'nl-NL'));
    };

    const fighterValues = cards
      .map((card) => ({
        card,
        name: normalize(card.dataset.name),
        country: normalize(card.dataset.country),
        countryLabel: card.dataset.country || '',
        sports: splitLabels(card.dataset.sports)
          .map(normalize),
        sportLabels: splitLabels(card.dataset.sports),
        roles: splitLabels(card.dataset.roles)
          .map(normalize),
        roleLabels: splitLabels(card.dataset.roles)
      }))
      .sort((a, b) => {
        return a.name.localeCompare(
          b.name,
          'nl-NL'
        );
      });

    const addOptions = (select, values) => {
      if (!select) return;

      const firstOption = select.options[0];

      select.innerHTML = '';

      if (firstOption) {
        select.appendChild(firstOption);
      }

      values.forEach((value) => {
        const option = document.createElement(
          'option'
        );

        option.value = normalize(value);
        option.textContent =
  select === roleSelect
    ? value.charAt(0).toLocaleUpperCase('nl-NL') + value.slice(1)
    : value;


        select.appendChild(option);
      });
    };

    const buildFilters = () => {
      addOptions(
        countrySelect,
        uniqueSorted(
          fighterValues.map(
            (fighter) => fighter.countryLabel
          )
        )
      );

      addOptions(
        sportSelect,
        uniqueSorted(
          fighterValues.flatMap(
            (fighter) => fighter.sportLabels
          )
        )
      );

      addOptions(
        roleSelect,
        uniqueSorted(
          fighterValues.flatMap(
            (fighter) => fighter.roleLabels
          )
        )
      );
    };

    const readFilters = () => {
      const params = new URLSearchParams(
        window.location.search
      );

      return {
        country: normalize(
          params.get('country') || ''
        ),
        sport: normalize(
          params.get('sport') || ''
        ),
        role: normalize(
          params.get('role') || ''
        ),
        page: Math.max(
          1,
          parseInt(params.get('page'), 10) || 1
        )
      };
    };

    const writeFilters = () => {
      const url = new URL(
        window.location.href
      );

      const filters = {
        country: countrySelect
          ? countrySelect.value
          : '',
        sport: sportSelect
          ? sportSelect.value
          : '',
        role: roleSelect
          ? roleSelect.value
          : '',
        page: currentPage
      };

      Object.entries(filters).forEach(
        ([key, value]) => {
          if (
            value &&
            !(key === 'page' && value === 1)
          ) {
            url.searchParams.set(key, value);
          } else {
            url.searchParams.delete(key);
          }
        }
      );

      window.history.replaceState(
        {},
        '',
        url
      );
    };

    const getFilteredFighters = () => {
      const country = normalize(
        countrySelect
          ? countrySelect.value
          : ''
      );

      const sport = normalize(
        sportSelect
          ? sportSelect.value
          : ''
      );

      const role = normalize(
        roleSelect
          ? roleSelect.value
          : ''
      );

      return fighterValues.filter((fighter) => {
        const matchesCountry =
          !country ||
          fighter.country === country;

        const matchesSport =
          !sport ||
          fighter.sports.includes(sport);

        const matchesRole =
          !role ||
          fighter.roles.includes(role);

        return (
          matchesCountry &&
          matchesSport &&
          matchesRole
        );
      });
    };

    const renderPagination = (total) => {
      if (!paginationElement) return;

      const totalPages = Math.ceil(
        total / perPage
      );

      if (totalPages <= 1) {
        paginationElement.innerHTML = '';
        return;
      }

      paginationElement.innerHTML = '';

      for (
        let page = 1;
        page <= totalPages;
        page += 1
      ) {
        const button = document.createElement(
          'button'
        );

        button.type = 'button';
        button.className =
          'f2w-event-directory__tab';

        if (page === currentPage) {
          button.classList.add('is-active');
        }

        button.textContent = page;
        button.setAttribute(
          'aria-label',
          String(page)
        );
        button.setAttribute(
          'aria-current',
          page === currentPage
            ? 'page'
            : 'false'
        );

        button.addEventListener(
          'click',
          () => {
            currentPage = page;
            render();
          }
        );

        paginationElement.appendChild(
          button
        );
      }
    };

    const render = () => {
      const filteredFighters =
        getFilteredFighters();

      const totalPages = Math.max(
        1,
        Math.ceil(
          filteredFighters.length / perPage
        )
      );

      if (currentPage > totalPages) {
        currentPage = totalPages;
      }

      const start =
        (currentPage - 1) * perPage;

      const visibleFighters =
        filteredFighters.slice(
          start,
          start + perPage
        );

      fighterValues.forEach((fighter) => {
        fighter.card.hidden = true;
      });

      visibleFighters.forEach((fighter) => {
        fighter.card.hidden = false;
        grid.appendChild(fighter.card);
      });

      if (countElement) {
        countElement.textContent =
          `${filteredFighters.length} ${labels.results}`;
      }

      if (emptyElement) {
        emptyElement.hidden =
          filteredFighters.length !== 0;
      }

      renderPagination(
        filteredFighters.length
      );

      writeFilters();
    };

    const applyUrlFilters = () => {
      const filters = readFilters();

      if (countrySelect) {
        countrySelect.value = filters.country;
      }

      if (sportSelect) {
        sportSelect.value = filters.sport;
      }

      if (roleSelect) {
        roleSelect.value = filters.role;
      }

      currentPage = filters.page;
    };

    if (countrySelect) {
      countrySelect.addEventListener(
        'change',
        () => {
          currentPage = 1;
          render();
        }
      );
    }

    if (sportSelect) {
      sportSelect.addEventListener(
        'change',
        () => {
          currentPage = 1;
          render();
        }
      );
    }

    if (roleSelect) {
      roleSelect.addEventListener(
        'change',
        () => {
          currentPage = 1;
          render();
        }
      );
    }

    if (resetButton) {
      resetButton.addEventListener(
        'click',
        () => {
          if (countrySelect) {
            countrySelect.value = '';
          }

          if (sportSelect) {
            sportSelect.value = '';
          }

          if (roleSelect) {
            roleSelect.value = '';
          }

          currentPage = 1;
          render();
        }
      );
    }

    const refreshFromHistory = () => {
      applyUrlFilters();
      render();
    };

    window.addEventListener(
      'pageshow',
      refreshFromHistory
    );

    window.addEventListener(
      'popstate',
      refreshFromHistory
    );

    buildFilters();
    applyUrlFilters();
    render();
  });
})();
